import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { IPManagement } from "@/components/security/ip-management";
import { KillSwitches } from "@/components/security/kill-switches";
import { SecurityEvents } from "@/components/security/security-events";
import { SecurityStats } from "@/components/security/security-stats";

export const Route = createFileRoute("/security/")({
  component: SecurityPage,
});

function SecurityPage() {
  return (
    <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
      <AppShell>
        <SecurityContent />
      </AppShell>
    </ProtectedRoute>
  );
}

function SecurityContent() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Security Management</h1>
        <p className="text-muted-foreground">
          Manage security controls, IP access, and system kill switches
        </p>
      </div>

      <SecurityStats />

      <Tabs defaultValue="ip" className="space-y-4">
        <TabsList>
          <TabsTrigger value="ip">IP Management</TabsTrigger>
          <TabsTrigger value="killswitches">Kill Switches</TabsTrigger>
          <TabsTrigger value="events">Security Events</TabsTrigger>
        </TabsList>

        <TabsContent value="ip" className="space-y-4">
          <IPManagement />
        </TabsContent>

        <TabsContent value="killswitches" className="space-y-4">
          <KillSwitches />
        </TabsContent>

        <TabsContent value="events" className="space-y-4">
          <SecurityEvents />
        </TabsContent>
      </Tabs>
    </div>
  );
}
